/**
 * Get next slide index
 */
export const getNextSlideIndex = (currentIndex, items) => {
	return currentIndex === items.length - 1 ? 0 : currentIndex + 1;
};
